"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./modules/Video.ts");
require("glightbox/src/postcss/glightbox.css");
require("../scss/glightbox.scss");
